import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import entityBase from "entityBase";

export class c_mk_to_product extends entityBase {
  created_dttm: KnockoutObservable<Date>;
  created_dateTime: KnockoutObservable<string>;
  formattedcreated_dttm: any;
  device_life_counter_after: KnockoutObservable<number>;
  device_life_counter_prior: KnockoutObservable<number>;
  device_model_id: KnockoutObservable<string>;
  device_product_id: KnockoutObservable<string>;
  device_serial_id: KnockoutObservable<string>;
  install_counter: KnockoutObservable<number>;
  install_date: KnockoutObservable<Date>;
  formattedinstall_date: KnockoutObservable<{}>;
  install_dt: string;
  mk_life_prolongation: KnockoutObservable<number>;
  mk_part_id: KnockoutObservable<string>;
  mk_product_id: KnockoutObservable<string>;
  mk_purchase_date: KnockoutObservable<Date>;
  formattedmk_purchase_date: any;
  mk_serial_id: KnockoutObservable<string>;
  request_unit_id: KnockoutObservable<string>;

  constructor(item: any) {
    super();
    this.created_dateTime = ko.observable(item.created_dttm);
    this.created_dttm = ko.observable(this.formatJSONDate(item.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
    this.device_life_counter_after = ko.observable(item.device_life_counter_after);
    this.device_life_counter_prior = ko.observable(item.device_life_counter_prior);
    this.device_model_id = ko.observable(item.device_model_id).extend({ maxLength: 128 });
    this.device_product_id = ko.observable(item.device_product_id).extend({ maxLength: 128 });
    this.device_serial_id = ko.observable(item.device_serial_id).extend({ maxLength: 128 });
    this.install_counter = ko.observable(item.install_counter);
    this.install_date = ko.observable(this.formatJSONDate(item.install_date));
    this.formattedinstall_date = CustomObservables.formattedDateTimeObservable(this.install_date);
    this.mk_life_prolongation = ko.observable(item.mk_life_prolongation);
    this.mk_part_id = ko.observable(item.mk_part_id).extend({ maxLength: 128 });
    this.mk_product_id = ko.observable(item.mk_product_id).extend({ maxLength: 128 });
    this.mk_purchase_date = ko.observable(this.formatJSONDate(item.mk_purchase_date));
    this.formattedmk_purchase_date = CustomObservables.formattedDateTimeObservable(this.mk_purchase_date);
    this.mk_serial_id = ko.observable(item.mk_serial_id).extend({ maxLength: 128 });
    this.request_unit_id = ko.observable(item.request_unit_id).extend({ maxLength: 32 });
  }
}
